export default [
  {
    name: 'etPageSetList',
    method: 'post',
    desc: '获取总公司Id',
    path: '/obt/etPageSetList',
    params: {
      // domainName:process.env.NODE_ENV === 'production' ? window.location.hostname : '127.0.0.1',//process.env.VUE_APP_addressHost,//
      domainName: window.location.hostname,//process.env.VUE_APP_addressHost,//
      sysType: 'etsmsapp'
    },
    loading: '0'
  },
  {
    name: 'getBClass',
    method: 'get',
    desc: '获取BCLASS',
    path: '/obt/getBClass',
    params: {
      parNo: 101
    }
  },
  {
    name: 'getFindNationList',
    method: 'post',
    desc: '获取国家数据',
    path: '/obt/bdc/findNationList',
    params: {
      nationId: '',
      nationName: '',
      nationEname: '',
      nationCode: ''
    }
  },
  {
    name: 'getParameter',
    method: 'get',
    desc: '获取单个控制参数',
    path: '/obt/getParameter',
    params: {
      paramNo: ''
    },
    loading: '0'
  },
  {
    name: 'queryParameter',
    method: 'post',
    desc: '获取多个控制参数',
    path: '/obt/admin/queryParameter',
    params: {
      paramNos: ''
    },
    loading: '0'
  },
  {
    name: 'queryVipParameter',
    method: 'post',
    desc: '获取企业级参数  新版',
    path: '/obt/queryVipParameter',
    params: {
      paramNo: ''
    },
    loading: '0'
  },
  {
    name: 'getSysParameter',
    method: 'post',
    desc: '获取oss产品设置控制参数',
    path: '/obt/admin/vipParam/getSysParameter',
    params: {
      paramNo: ''
    },
    loading: '0'
  },
  {
    name: 'getSysParameterallow',
    method: 'post',
    desc: '获取oss产品设置控制参数接接口',
    path: '/obt/admin/vipParam/getSysParameter/allow',
    params: {
      paramNo: '',
      companySuper: '',
    },
    loading: '0'
  },
  {
    name: 'costCenterFindList',
    method: 'post',
    desc: '获取成本中心列表',
    path: '/obt/costCenterFindList',
    params: {
      projectId: '',
      travelEmpId: '',
      txEmpIds: ''
    }
  },
  // GET /obt/vipCostcenterFindList
  // 分页查询企业所有成本中心的列表
  {
    name: 'vipCostcenterFindList',
    method: 'get',
    desc: '获取成本中心列表分页',
    path: '/obt/vipCostcenterFindList',
    params: {
      costCenterCode: '',
      count: '20',
      pageNum: '1'
    }
  },
  {
    name: 'projectList',
    method: 'post',
    desc: '获取项目列表',
    path: '/obt/projectList',
    params: {
      count: 999,
      keywords: '',
      pageNum: 1,
      status: ''
    }
  },
  {
    name: 'vipCcsqdGetListForChoose',
    method: 'get',
    desc: '获取出差申请单列表控件',
    path: '/obt/vipCcsqdGetListForChoose',
    params: {
      pageNum: '1', //默认显示第一页
      count: '20',  //每页显示10条数据
      ccsqdId: '',//出差申请单id，或者申请单号
      proType: '',  //产品类型
      dateBegin: '',//  日期开始
      dateEnd: '',   //日期结束
    }
  },
  {
    name: 'vipCcsqdGetList',
    method: 'get',
    desc: '获取出差申请单列表',
    path: '/obt/vipCcsqdGetList',
    params: {
      pageNum: '1', //默认显示第一页
      count: '20',  //每页显示10条数据
      status: '2',  //已经审批通过的
      proType: '',  //产品类型
      dateBegin: '',//  日期开始
      dateEnd: '',   //日期结束
      dateType: '1',//(1申请日期2出差日期)
      ccr: '',
    }
  },
  {
    name: 'vipCcsqdGetInfo',
    method: 'get',
    desc: '获取出差申请单详情',
    path: '/obt/vipCcsqdGetInfo',
    params: {
      ccsqdId: '',
    }
  },
  {
    name: 'vipCcsqdAdd',
    method: 'post',
    desc: '保存草稿/提交送审出差申请单功能接口',
    path: '/obt/vipCcsqdAdd',
    params: {
      'addMethod': 0,//1保存草稿 2保存并提交送审 3保存后无需审批
      'appId': '',
      'ccr': '',
      'ccsqdId': '',
      'ccsqdNo': '',
      'ccsy': '',
      'costCenterCode': '',
      'costCenterId': '',
      'costCenterName': '',
      'dateBegin': '',
      'dateEnd': '',
      'delPersonIds': '',
      'delRouteIds': '',
      'jtys': 0,
      'mdd': '',
      'project': '',
      'projectCode': '',
      'projectId': '',
      'projectName': '',
      'qtys': 0,
      'remark': '',
      'subjectCode': '',
      'sxr': '',
      'vipPerson': [],
      'vipRoute': [],
      'zsys': 0,
      'zys': 0
    }
  },
  {
    name: 'vipCcsqdDel',
    method: 'get',
    desc: '删除出差申请单草稿',
    path: '/obt/vipCcsqdDel',
    params: {
      ccsqdId: '',
    }
  },
  {
    name: 'getParListByCodes',
    method: 'post',
    desc: '根据编号获取',
    path: '/obt/getParListByCodes',
    params: {
      codes: ''
    },
    loading: '0'
  },
  {
    name: 'vipJcsjbGetList',
    method: 'get',
    desc: '获取...科目码？？？',
    path: '/obt/vipJcsjbGetList',
    params: {
      lb: ''
    }
  },
  {
    name: 'violateReasonList',
    method: 'get',
    desc: '违背原因控件',
    path: '/obt/violateReasonList',
    params: {
      by1: '10901' // 产品类型
    }
  },
  {
    name: 'ylgqList',
    method: 'post',
    desc: '预留改签',
    path: '/obt/plane/tkOrder/ylgqList',
    params: {
      dateType: '',
      drawDateEnd: "",
      drawDateStart: '',
      // 预留改签
    }
  },
  {
    name: 'totalOrderList',
    method: 'post',
    desc: '获取全部订单',
    path: '/obt/totalOrderList',
    params: {
      ccsqdId: '',//出差申请单id
      count: 10,
      dateEnd: '',
      dateStart: '',
      dateType: 1, // 1 预订日期,2 是出发/入住日期
      findScope: null, // 1是个人订单,2是全部订单 ,
      findType: null,	// 1全部订单 2待支付 3待出行 4退改 5指定的业务订单（productType必须传值）
      pageNum: null,//当前页
      productType: '', //: 产品类型(10901国内机票,10902国际机票,10903酒店,10904火车票,10999其他)
      psgName: '', // 乘机人
      tripType: '',
      queryType: '',
    }
  },
  {
    name: 'allOrderList',
    method: 'post',
    desc: '获取全部订单',
    path: '/obt/plane/tkOrder/allOrderList',
    params: {
      ccsqdId: '',//出差申请单id
      count: 10,
      dateEnd: '',
      dateStart: '',
      orderNo: '',
      dateType: 1, // 1 预订日期,2 是出发/入住日期
      findScope: null, // 1是个人订单,2是全部订单 ,
      findType: null,	// 1全部订单 2待支付 3待出行 4退改 5指定的业务订单（productType必须传值）
      pageNum: null,//当前页
      productType: '', //: 产品类型(10901国内机票,10902国际机票,10903酒店,10904火车票,10999其他)
      psgName: '', // 乘机人
      tripType: '',
      needInternational: 0
    },
    loading: '0'
  },
  {
    name: 'totalCount',
    method: 'post',
    desc: '获取所有类型订单数量',
    path: '/obt/totalCount',
    params: {
      dateEnd: '',
      dateStart: '',
      dateType: 1, // 1 预订日期,2 是出发/入住日期
      findScope: null, // 1是个人订单,2是全部订单 ,
      findType: null,	// 1全部订单 2待支付 3待出行 4退改 5指定的业务订单（productType必须传值）
      orderNo: '',
      productType: '', //: 产品类型(10901国内机票,10902国际机票,10903酒店,10904火车票,10999其他)
      psgName: '', // 乘机人
      tripType: '',
      queryType: ''
    },
    loading: '0'
  },
  {
    name: 'vipOrderAppProgress',
    method: 'post',
    desc: '获取进度退改签...',
    path: '/obt/vipOrderAppProgress',
    params: {
      orderId: '',
      orderType: ''
    }
  },
  {
    name: 'getPaySubject',
    method: 'post',
    desc: '获取支付科目',
    path: '/obt/getPaySubject',
    params: {
      'orderBeans': [],
      'payScene': '',
      'type': '',

    }
  },
  {
    name: 'onlinePay',
    method: 'post',
    desc: '支付 单科目',
    path: '/obt/onlinePay',
    params: {
      'orderList': '',
      'payMethod': '',
      'payScene': '',
      'paySubject': '',
      'payPwd': '',
      'buyerId': '',
      'zcyh': ''
    }
  },
  {
    name: 'onlinePayNewUnionpayCp',
    method: 'post',
    desc: '在线支付接口 多科目',
    path: '/obt/pay/online',
    params: {
      'buyerId': '',
      'orderList': [
        // {
        // 	'orderId': '',
        // 	'orderNo': '',
        // 	'orderType': '',
        // 	'payAmount': 0,
        // 	'payRemark': ''
        // }
      ],
      'payPwd': '',
      'payScene': '',
      'subjectBeanList': [
        // {
        // 	'payMethod': '',
        // 	'paySubject': '',
        // 	'payAmount': 0,
        // 	'jfAmount': ''
        // }
      ],
      'webHost': '',
      'zcyh': '',
    },
    loading: '0'
  },
  {
    name: 'onlinePayNew',
    method: 'post',
    desc: '在线支付接口 多科目',
    path: '/obt/pay/online',
    params: {
      'buyerId': '',
      'orderList': [
        // {
        // 	'orderId': '',
        // 	'orderNo': '',
        // 	'orderType': '',
        // 	'payAmount': 0,
        // 	'payRemark': ''
        // }
      ],
      'payPwd': '',
      'payScene': '',
      'subjectBeanList': [
        // {
        // 	'payMethod': '',
        // 	'paySubject': '',
        // 	'payAmount': 0,
        // 	'jfAmount': ''
        // }
      ],
      'webHost': '',
      'zcyh': ''
    }
  },
  {
    name: 'gatPay',
    method: 'post',
    desc: '关爱通唤醒收银台支付',
    path: '/obt/pay/gatPay',
    params: {
      'orderId': '',
      'orderType': ''
    }
  },
  {
    name: 'queryOnlinePayStatus',
    method: 'get',
    desc: '获取支付状态',
    path: '/obt/queryOnlinePayStatus',
    params: {
      'orderType': '',
      'orderId': '',
    },
    loading: '0'
  },
  {
    name: 'getPayOrderIdList',
    method: 'get',
    desc: '获取支付订单',
    path: '/obt/getPayOrderIdList',
    params: {
      'payInfoId': '',
    }
  },
  // POST /obt/pay/getSmsCode
  // 获取支付验证码
  {
    name: 'getSmsCode',
    method: 'post',
    desc: '获取支付验证码',
    path: '/obt/pay/getSmsCode',
    params: {
      'orderId': '',
      'orderNo': '',
      'orderType': ''
    }
  },
  // POST /obt/pay/smsCodeCheck
  // 校验支付验证码
  {
    name: 'smsCodeCheck',
    method: 'post',
    desc: '校验支付验证码',
    path: '/obt/pay/smsCodeCheck',
    params: {
      'smsCode': '',
    }
  },
  {
    name: 'policyList',
    method: 'post',
    desc: '产品发布详情',
    path: '/obt/yyzx/policy/list',
    params: {}
  },
  {
    name: 'policyDetail',
    method: 'post',
    desc: '产品发布列表',
    path: '/obt/yyzx/policy/detail',
    params: {
      id: null
    }
  },
  {
    name: 'airportBus',
    method: 'post',
    desc: '机场大巴-列表展示',
    path: '/obt/plane/set/agreement/airportBusQuery',
    params: {}
  },
  {
    name: 'smsSend',
    method: 'post',
    desc: '发送短信',
    path: '/obt/common/smsSend',
    params: {
      phoneNumber: '',
      sendContent: ''
    }
  },
  {
    name: 'queryWcxOrder',
    method: 'get',
    desc: '获取存在本系统的未出行或者未到达的订单 查询当前人航班',
    path: '/obt/queryWcxOrder',
    params: {
      ywlx: 1,
      ccsqdNo: ''
    }
  },
  {
    name: 'queryTrainNumber',
    method: 'post',
    desc: '查询当前人车次',
    path: '/obt/queryTrNumber',
    params: {
      'booker': '',
    }
  },
  {
    name: 'getAuthorizationPnos',
    method: 'post',
    desc: '获取home页面菜单栏需要显示的产品',
    path: '/obt/sys/privilege/getAuthorizationPnos',
    params: {},
    loading: '0'
  },
  {
    name: 'getAuthorizationPnosNoLogin',
    method: 'post',
    desc: '获取无登陆信息时home页面菜单栏需要显示的产品',
    path: '/obt/sys/privilege/getAuthorizationPnosNoLogin',
    params: {},
    loading: '0'
  },
  {
    name: 'getLoginTz',
    method: 'post',
    desc: '登陆接收公告通知',
    path: '/obt/getLoginTz',
    params: {
      flag: null
    },
    loading: '0'
  },
  {
    name: 'recipientGgtz',
    method: 'post',
    desc: '接收公告通知列表查询',
    path: '/obt/sms/findGgtzRead',
    params: {
      queryType: 0,
      status: '', // 是否已读 0未读 1已读 默认则全部
      pageNum: 1,
      count: 20
    },
    loading: '0'
  },
  {
    name: 'findGgtzReadCount',
    method: 'post',
    desc: '接收公告通知列表标签数量',
    path: '/obt/sms/findGgtzReadCount',
    params: {},
    loading: '0'
  },
  {
    name: 'getTzContent',
    method: 'post',
    desc: '查看通知内容',
    path: '/obt/getTzContent',
    params: {
      id: ''
    }
  },
  {
    name: 'readGgtz',
    method: 'post',
    desc: '读公告通知',
    path: '/obt/readGgtz',
    params: {
      id: '',
      isRead: true
    }
  },
  {
    name: 'allGgTz',
    method: 'post',
    desc: '所有公告消息类型列表',
    path: '/obt/sms/allGgTz',
    params: {}
  },
  {
    name: 'findGgtzByMsgType',
    method: 'post',
    desc: '根据消息类型获取消息',
    path: '/obt/sms/findGgtzByMsgType',
    params: {
      'msgType': 0,
      'productType': ''
    }
  },
  {
    name: 'getGidForGroup',
    method: 'get',
    desc: '获取客服服务组ID 米多客',
    path: '/obt/admin/vipCorp/getGidForGroup',
    params: {}
  },
  {
    name: 'smsEmail',
    method: 'post',
    desc: '附件下载',
    path: '/obt/common/smsEmail',
    params: {
      'sendScene': 1, //发送场景 1 电子保单 2 电子发票 3 保险条款 4 签证资料模板下载 5 订单详情PDF下载
      'url': '',
      'bdh': '',
      'emailUrl': '',
      'orderNo': '',
      'orderType': '',
    },
    loading: '0'
  },
  {
    name: 'commUpdateById',
    method: 'post',
    desc: '根据id编辑员工邮箱',
    path: '/obt/commUpdateById',
    params: {
      'id': '',
      'email': '',
    },
    loading: '0'
  },
  {
    name: 'getCxtxInfo',
    method: 'post',
    desc: '根据城市获取出行提醒',
    path: '/obt/yyzx/tzgl/getCxtxInfo',
    params: {
      'cityId': '',
    },
    loading: '0'
  },
  {
    name: 'uploadCons',
    method: 'post',
    desc: '订单附件上传',
    path: '/obt/vipCorp/fj/uploadCons',
    params: {
      'beanList': '',
    },
  },
  {
    name: 'queryFj',
    method: 'post',
    desc: '订单附件查看',
    path: '/obt/vipCorp/fj/queryFj',
    params: {
      cjlx: '',// (integer, optional): 场景类型 1 非自愿退凭证2订单附件 ,
      glywlx: '',// (string, optional): 关联业务类型 ,
      gldd: '',// (string, optional): 关联订单id
    },
  },
  {
    name: 'generate',
    method: 'post',
    desc: '下载PDF',
    path: '/obt/vipOrder/pdf/generate',
    params: {
      djlx: '',
      orderId: '',
      imgLog: '',
    },
  },
  {
    name: 'pullData',
    method: 'post',
    desc: '获取广告',
    path: '/obt/yyzx/advertising/pullData',
    params: {
      requestFrom: '',
    },
    loading: '0'
  },
  {
    name: 'getSdkQx',
    method: 'post',
    desc: '微信JS-SDK使用权限签名',
    path: '/obt/comm/wx/getSdkQx',
    params: {
      url: ''
    }
  },
  {
    name: 'unionpayCpTn',
    method: 'post',
    desc: '银联cp支付获取tn号',
    path: '/obt/pay/unionpayCpTn',
    params: {
      'payInfoId': ''
    },
    loading: '0'
  },
  {
    name: 'checkCcsqdPersonIsBook',
    method: 'post',
    desc: '验证出差申请单的出行人是否预定机票',
    path: '/obt/checkCcsqdPersonIsBook',
    params: {
      routeId: '',
      empIds: [],
      empNames: [],
    }
  },
  {
    name: 'ccsqdxcydmx',
    method: 'post',
    desc: '出差申请单行程预定明细',
    path: '/obt/ccsqdxcydmx',
    params: {
      routeId: '',
    }
  },
  {
    name: 'tr_ccsqdxcydmx',
    method: 'post',
    desc: '出差申请单行程预定明细',
    path: '/obt/tr/ccsqdxcydmx',
    params: {
      routeId: '',
    }
  },
  {
    name: 'ht_ccsqdxcydmx',
    method: 'post',
    desc: '出差申请单行程预定明细',
    path: '/obt/ht/ccsqdxcydmx',
    params: {
      routeId: '',
    }
  },
]
